import React, {Component, Fragment} from 'react';
import {getRoomEnhanced} from "../../../../selectors/room";
import {bindActionCreators} from "redux";
import {fetchRoomMedias, resetRoomMedias} from "../../../../creators/room.medias";
import {
    archivedRoom,
    fetchRoom,
    joinRoom,
    leaveRoom,
    lockRoom,
    readRoom,
    removeRoomByUser,
    updateRoom
} from "../../../../creators/room";
import {connect} from "react-redux";
import history from "../../../../libs/history";
import createLink from "../../../../libs/createLink";
import _ from "lodash";
import {LoadingBar} from "../../../components/Loader";
import RoomProfile from "../components/RoomProfile";
import DisplayImage from "../../../components/DisplayImage";
import Modal from "../../../components/Modal";
import {toast} from "react-toastify";

class MessengerMobileRoomInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleMediaViewer: false,
            openMediaIndex: 0,
            page: 1
        }
    }

    componentDidMount() {
        if (!this.props.roomInitialized) {
            this._fetchRoom(this.props.match.params.room);
        }
    }

    componentWillUnmount() {
        this.props.resetRoomMedias();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.match.params.room !== prevProps.match.params.room) {
            this._fetchRoom(this.props.match.params.room);
        }
    }

    _fetchRoom(roomId) {
        this.props.fetchRoom(roomId);
        this.props.fetchRoomMedias(roomId, {sort : "-createdAt"});
    }

    _handleRoomMarkRead(isRead) {
        this.props.readRoom(this.props.room._id, {read: isRead});
    }

    _handleRoomArchived(isAchived) {
        if(isAchived){
            toast("Cette conversation vient d'être archivée. Vous pouvez retrouver les conversations archivées en cliquant sur Filtres / Conversations archivées.",{
                autoClose: 10000,
                className: 'toast-background toast-success w-100',
                bodyClassName: "toast-font toast-success",
                progressClassName: 'toast-loader toast-success'
            });
        }
        this.props.archivedRoom(this.props.room._id, {archived: isAchived});
    }

    _handleAddUser(userId) {
        this.props.joinRoom(this.props.room._id, {userId});
    }

    _handleChangeGroupTitle(groupName) {
        this.props.updateRoom(this.props.room._id, {groupName});
    }

    _handleRoomLock() {
        this.props.lockRoom(this.props.room._id, {locked: !this.props.room.isLocked});
    }

    _handleUserLeave(userId) {
        this.props.leaveRoom(this.props.room._id, {userId});
        if (this.props.room.owner._id === userId) history.push(createLink("messenger"));
    }

    _handleOpenMedia(mediaId) {
        //todo : bug possible : media ouvert à partir d'un message qui ne serait pas chargé dans les médias de la room
        this.setState({
            toggleMediaViewer: true,
            openMediaIndex: _.findIndex(this.props.medias, (o) => o._id === mediaId)
        });
    }

    _handleMediaMore(){
        let page = this.state.page + 1;
        this.props.fetchRoomMedias(this.props.room._id, {page, sort : "-createdAt"}, this.props.mediasMore);
        this.setState({page})
    }

    _handleRemoveRoom(roomId){
        this.props.removeRoomByUser(roomId);
        history.push(createLink("messenger"))
    }

    _closeOpenMedia() {
        this.setState({
            toggleMediaViewer: false,
            openMediaIndex: 0
        });
    }

    render() {

        return (!this.props.roomInitialized)
            ? <LoadingBar/>
            : <Fragment>
                <div className="layout-sidebar">
                    <div className="sidebar right">
                        <RoomProfile
                            mobile
                            room={this.props.room}
                            medias={this.props.medias}
                            mediasMore={this.props.mediasMore}
                            currentUser={this.props.currentUser}
                            handleRoomMarkRead={this._handleRoomMarkRead.bind(this)}
                            handleAddUser={this._handleAddUser.bind(this)}
                            handleChangeGroupTitle={this._handleChangeGroupTitle.bind(this)}
                            handleUserLeave={this._handleUserLeave.bind(this)}
                            handleRoomLock={this._handleRoomLock.bind(this)}
                            handleOpenMedia={this._handleOpenMedia.bind(this)}
                            handleRoomArchived={this._handleRoomArchived.bind(this)}
                            handleMediaMore={this._handleMediaMore.bind(this)}
                            handleRemoveRoom={this._handleRemoveRoom.bind(this)}
                        />
                    </div>
                </div>
                <Modal toggle={this.state.toggleMediaViewer}
                       handleClose={() => this._closeOpenMedia()}>
                    <DisplayImage
                        handleClose={() => this._closeOpenMedia()}
                        mediaAttachementArray={this.props.medias}
                        currentIndex={this.state.openMediaIndex}
                    />
                </Modal>
            </Fragment>
    }
}

const mapStateToProps = (state, props) => {
    return {
        roomInitialized: state.room.initialized,
        roomLoading: state.room.loading,
        medias: state.roomMedias.data,
        mediasMore: state.roomMedias.more,
        room: getRoomEnhanced(state),
        currentUser: state.currentUser.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchRoomMedias,
    resetRoomMedias,
    updateRoom,
    fetchRoom,
    readRoom,
    leaveRoom,
    joinRoom,
    lockRoom,
    archivedRoom,
    removeRoomByUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MessengerMobileRoomInfo);